import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import {  KhoaHocs_ThongTinKhoaHoc } from '../../../routes/menu'
import { BsModalComponent } from 'ng2-bs3-modal';
import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
  selector: 'app-daotao-dangkygoihocedit',
  templateUrl: './dangkygoihocedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./dangkygoihocedit.component.scss'],
    providers: [ListService, Repository]
})


export class dangkygoihoceditComponent implements OnInit {
  donviid: string = null;
  dslops: any;
  vouchers: any;
  dschinhanhs: any;
  dskhoahocs: any;
  doanhnghiepid: string = null;
  public ngaysinh: Date = null;
  public ngaycmnd: Date = null;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputhangbaohiems: any;
  inputphongbans: any;
  inputhangxes: any;
  inputkhachhangs: any;
  inputmausacs: any;
  inputmodels: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  //========================phan bo doanh thu
  months: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  years: number[] = [];
  tuThang: number = new Date().getMonth() + 1;
  tuNam: number = new Date().getFullYear();
  denThang: number = new Date().getMonth() + 1;
  denNam: number = new Date().getFullYear();
  soTienPhanBo: number = 0;
  danhSachPhanBo: any[] = [];
  activeTab: string = 'thongtinchung'; // Default tab

  //========================================================
  doituongSelect: any = {
    Id: null, DonViId: null, NhanSuId: null, NgayDangKy: null
    , KhoaHocId: null, GiaPhi: null, DangKy: null
    , SoBuoi: null, DuocGiam: null, ThucThu: null, LyDoGiam: null, GhiChu: null
    , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    , TyLe: null, LopId: null, ApDungChoCalop: false
  };       
    nhomdtid:string=null;
  hoatdong: string = null;
  inputnhacungcaps: any = [
    { Ten_Doi_Tuong: "Cá nhân", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Tổ chức", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputdangkys: any = [
    { Ten: 'Đăng ký mới', Id: 0 },
    { Ten: 'Gia hạn (tái tục)', Id: 1 },
  ];

  inputloaikhoans: any = [
    { Ten: 'Học phí', Id: 0 },
    { Ten: 'Thu khác', Id: 1 },
    { Ten: 'Giảm trừ', Id: 2 },
  ];

  inputloais: any = [
    { text: "Nhân công", value: 0 },
    { text: "Vật tư sơn", value: 1 },
  ];

  dsGiaTienLop: any[] = [];

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();

  @ViewChild('mdChonDoiTuongChung') mdChonDoiTuongChung: BsModalComponent;
  @ViewChild('dtechondoituongchungedit') dtechondoituongchungedit: any;

  @ViewChild('myModal')
  myModal: BsModalComponent;
  @ViewChild('dteChung') doituongchungedit: any;
  
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

    constructor( private _dataService: ListService, public repo: Repository) {
       
        
    }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
    ngOnInit(): void {
      
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }
  setActiveTab(tabId: string) {
    this.activeTab = tabId;
  }
    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  tieudectmt: any;
  tieudectmtplace: any;
  public changeChiNhanh1($event: any) {
    if (typeof $event === "undefined") {
      this.donviid = null;
    }
    else {
      this.donviid = $event.Id;
      this.repo.postRequest('api/hoso/combolophoc', { UserName: this.currentUser.user_name, DonViId: this.donviid })
        .subscribe(response => {
          this.dslops = response;

        });
    }
  }
  loadDataInit2(nhomdoituongid: string, id: string, donviid: string, rowdata: any, nhansuid: string, loai: number) {
    console.log(loai);
    this.loadDataInitGoc(nhomdoituongid, id, donviid, rowdata, nhansuid,loai);
  }
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, rowdata: any, nhansuid: string) {
    this.loadDataInitGoc(nhomdoituongid, id, donviid, rowdata, nhansuid,0);
  }
  loadDataInitGoc(nhomdoituongid: string, id: string, donviid: string, rowdata: any, nhansuid: string, loai: number) {

    
    this.tieudectmtplace = "Ghi chú";
    this.tieudectmt = "Ghi chú";
    this.hoatdong = "Hoạt động"

   

    // Generate years for dropdown (current year - 5 to current year + 5)
    const currentYear = new Date().getFullYear();
    for (let year = currentYear - 5; year <= currentYear + 5; year++) {
      this.years.push(year);
    }

    // Initialize soTienPhanBo with doituongSelect.ThucThu
    //this.soTienPhanBo = this.doituongSelect.ThucThu || 0;

   


          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            this.currentUser = JSON.parse(authlogin);
            var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
            if (giatri != null && giatri.length > 0) {
              if (giatri[0].Them == true)
                this.quyen_them = true;
              else
                this.quyen_them = false;
              if (giatri[0].Sua == true)
                this.quyen_sua = true;
              else
                this.quyen_sua = false;
              if (giatri[0].Xoa == true)
                this.quyen_xoa = true;
              else
                this.quyen_xoa = false;
            }

            

          }    

    this.donviid = this.currentUser.id_don_vi;

    this.repo.postRequest('api/login/gettrungtam2s', { UserName: this.currentUser.user_name })
      .subscribe(response => {
        this.dschinhanhs = response;

      });

    this.repo.postRequest('api/khoahoc/getkhoahocbychinhanh', { UserName: this.currentUser.user_name, DonViId: this.currentUser.id_don_vi })
      .subscribe(response => {
        this.dskhoahocs = response;

      });

    this.repo.postRequest('api/hoso/combolophoc', { UserName: this.currentUser.user_name, DonViId: this.donviid })
      .subscribe(response => {
        this.dslops = response;

      });

    

        this.nhomdtid = nhomdoituongid;
 
    
    
    this.doituongSelect = {
      Id: null, DonViId: null, NhanSuId: null, NgayDangKy: null
      , KhoaHocId: null, GiaPhi: null, DangKy: null,Nhom:loai
      , SoBuoi: null, DuocGiam: null, ThucThu: null, LyDoGiam: null, GhiChu: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
      , TyLe: null, LopId: null, ApDungChoCalop: false
    };

    this.doituongSelect.DonViId = parseInt(this.currentUser.id_don_vi);

    // Load giá tiền theo lớp cho học viên
    if (nhansuid) {
      this.loadGiaTienTheoLop(nhansuid, this.donviid);
    }

    if (id === null)
    {
      

        this.doituongSelect.NgayDangKy = new Date();
        this.doituongSelect.NhanSuId = nhansuid;
          this.doituongSelect.Created = new Date();
          this.doituongSelect.CreatedBy = this.currentUser.user_name;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;         
      this.danhSachPhanBo = [];

    }
        else {
      console.log("t11");

      this.loadPhanBo(id);

      this.repo.postRequest("api/dangkygoihoc/getbyid_dangky/", { IdGuid: id, NhomDoiTuongId: nhomdoituongid, UserName: this.currentUser.user_name })
            .subscribe(response => {  
                console.log(response);
              this.doituongSelect.Id = id;
              this.doituongSelect.NhanSuId = nhansuid;
              this.doituongSelect.DonViId = response.DonViId;
              this.doituongSelect.KhoaHocId = response.KhoaHocId;

              this.doituongSelect.GiaPhi = response.GiaPhi;
              this.doituongSelect.DangKy = response.DangKy;
              this.doituongSelect.Nhom = response.Nhom;              
              this.doituongSelect.SoBuoi = response.SoBuoi;
              this.doituongSelect.DuocGiam = response.DuocGiam;
              this.doituongSelect.ThucThu = response.ThucThu;
              this.doituongSelect.LyDoGiam = response.LyDoGiam;
              this.doituongSelect.GhiChu = response.GhiChu;
              this.doituongSelect.LopId = response.LopId;
                            
              this.doituongSelect.Created = response.Created;
              this.doituongSelect.CreatedBy = response.CreatedBy;
              this.doituongSelect.Modified = new Date();
              this.doituongSelect.ModifiedBy = this.currentUser.user_name;

             // this.doituongSelect.TrangThai = response.TrangThai==1?true:0;

              if (response.NgayDangKy != null)
                this.doituongSelect.NgayDangKy = new Date(response.NgayDangKy);
              else
                this.doituongSelect.NgayDangKy = null;
              
              if (response.NgayKetThuc != null)
                this.doituongSelect.NgayKetThuc = new Date(response.NgayKetThuc);
              else
                this.doituongSelect.NgayKetThuc = null;
           
            }); 
        }
        
       
  }
  loadGiaTienTheoLop(nhansuid: string, donviid: string) {
    this.repo.getRequest('api/hocvien/getgiatientheolop', {
      userid: nhansuid,
      donviid: donviid
    }).subscribe(response => {
      if (response && response.success) {
        this.dsGiaTienLop = response.data;
        console.log('Danh sách giá tiền theo lớp:', this.dsGiaTienLop);
      } else {
        this.dsGiaTienLop = [];
        console.warn('Không lấy được giá tiền theo lớp:', response?.message);
      }
    }, error => {
      this.dsGiaTienLop = [];
      console.error('Lỗi khi lấy giá tiền theo lớp:', error);
    });
  }

  // Modify existing changeTrangThai method to handle LopId change
  public changeLop($event: any) {
    console.log("Gọi hàm changeLop")
    if (typeof $event === "undefined" || !$event) {
      return;
    }

    const lopId = $event.Id || $event;

    // Find tuition fee for selected class
    const giaTienLop = this.dsGiaTienLop.find(x => x.LopId === lopId);

    if (giaTienLop && this.doituongSelect.SoBuoi > 0 &&
      (this.doituongSelect.ThucThu === 0 || !this.doituongSelect.ThucThu)) {

      // Calculate ThucThu = SoBuoi * ChiPhiDaoTao_CT
      const soTienTinh = this.doituongSelect.SoBuoi * giaTienLop.ChiPhiDaoTao_CT;

      // Update ThucThu and GiaPhi
      this.doituongSelect.ThucThu = soTienTinh;
      this.doituongSelect.GiaPhi = soTienTinh;

      console.log(`Tính học phí: ${this.doituongSelect.SoBuoi} buổi x ${giaTienLop.ChiPhiDaoTao_CT} = ${soTienTinh}`);
    }
  }

  // Update SoBuoi change handler
  public changeSoBuoi() {
    console.log("Gọi hàm changeLop")
    if (!this.doituongSelect.LopId || !this.doituongSelect.SoBuoi) {
      return;
    }

    // Find tuition fee for current class
    const giaTienLop = this.dsGiaTienLop.find(x => x.LopId === this.doituongSelect.LopId);

    if (giaTienLop && (this.doituongSelect.ThucThu === 0 || !this.doituongSelect.ThucThu)) {
      // Calculate ThucThu = SoBuoi * ChiPhiDaoTao_CT
      const soTienTinh = this.doituongSelect.SoBuoi * giaTienLop.ChiPhiDaoTao_CT;

      // Update ThucThu and GiaPhi
      this.doituongSelect.ThucThu = soTienTinh;
      this.doituongSelect.GiaPhi = soTienTinh;

      console.log(`Tính học phí theo số buổi: ${this.doituongSelect.SoBuoi} x ${giaTienLop.ChiPhiDaoTao_CT} = ${soTienTinh}`);
    }
  }
  public changeGiaPhi() {
    // Automatically calculate ThucThu when GiaPhi changes
    this.doituongSelect.ThucThu = (this.doituongSelect.GiaPhi != null ? this.doituongSelect.GiaPhi : 0)
      - (this.doituongSelect.DuocGiam != null ? this.doituongSelect.DuocGiam : 0);
  }
    keyTenPress(event: any) { 
        if (event.which === 13) {
            this.slCapTren.focus();
            event.preventDefault();
          }
   }
    public closeModal(){
        this.save.emit(null);
  }
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  xoaVoucher(id: string) {

  }
  
  AddKhoaHoc() {

    this.doituongchungedit.loadDataInit(KhoaHocs_ThongTinKhoaHoc.id, null, this.currentUser.id_don_vi);
    this.myModal.open();
    
  }
  saveModal(doituong: any) {
    this.myModal.close();
    this.dskhoahocs.push({
      Id: doituong.Id, Ten: doituong.Ten
      , SoTien: doituong.SoTien, GiamGia: doituong.GiamGia, SoBuoi: doituong.SoBuoi
      , Ma: doituong.Ma
    })
    this.dskhoahocs = this.dskhoahocs.slice();
    this.doituongSelect.KhoaHocId = doituong.Id;

  }
  public changeTrangThai($event: any) {
    if (typeof $event === "undefined") {
      //this.doituongSelect.TrangThai = null;
      
    }
    else {
      this.doituongSelect.SoBuoi = $event.SoBuoi;
      this.doituongSelect.GiaPhi = $event.SoTien;
      this.doituongSelect.DuocGiam = $event.GiamGia;
      this.doituongSelect.ThucThu = ($event.SoTien != null ? $event.SoTien : 0)
        - ($event.GiamGia != null ? $event.GiamGia : 0);
      
    }
  }
  public changeDuocGiam() {
    if (this.doituongSelect.DuocGiam !== null) {
      
      this.doituongSelect.ThucThu = (this.doituongSelect.GiaPhi != null ? this.doituongSelect.GiaPhi : 0)
        - (this.doituongSelect.DuocGiam != null ? this.doituongSelect.DuocGiam : 0);
    }

  }
  public changeTyLe() {
    if (this.doituongSelect.TyLe !== null) {
      this.doituongSelect.DuocGiam = (this.doituongSelect.GiaPhi != null ? this.doituongSelect.GiaPhi : 0) * this.doituongSelect.TyLe/100;
      this.doituongSelect. ThucThu = (this.doituongSelect.GiaPhi != null ? this.doituongSelect.GiaPhi : 0)
        - (this.doituongSelect.DuocGiam != null ? this.doituongSelect.DuocGiam : 0);
    }

  }
  phanBoDoanhThu() {
    this.soTienPhanBo = this.doituongSelect.ThucThu;
    if (!this.soTienPhanBo) {
      swal('Lỗi!', 'Vui lòng nhập số tiền phân bổ!', 'error');
      return;
    }

    // Calculate number of months between start and end dates
    const startDate = new Date(this.tuNam, this.tuThang - 1, 1);
    const endDate = new Date(this.denNam, this.denThang - 1, 1);

    if (startDate > endDate) {
      swal('Lỗi!', 'Thời gian bắt đầu phải nhỏ hơn thời gian kết thúc!', 'error');
      return;
    }

    // Calculate months difference
    const months = (endDate.getFullYear() - startDate.getFullYear()) * 12 +
      (endDate.getMonth() - startDate.getMonth()) + 1;

    if (months <= 0) {
      swal('Lỗi!', 'Khoảng thời gian phân bổ không hợp lệ!', 'error');
      return;
    }

    // Amount per month
    const amountPerMonth = this.soTienPhanBo / months;

    // Clear existing allocations
    this.danhSachPhanBo = [];

    // Create allocations for each month
    for (let i = 0; i < months; i++) {
      const allocationDate = new Date(startDate);
      allocationDate.setMonth(startDate.getMonth() + i);

      // Set to last day of month
      const lastDay = new Date(allocationDate.getFullYear(), allocationDate.getMonth() + 1, 0);

      this.danhSachPhanBo.push({
        Id: null,
        ChungTuId: this.doituongSelect.Id,
        Ngay: lastDay,
        SoTien: amountPerMonth,
        GhiChu: `Phân bổ tháng ${allocationDate.getMonth() + 1}/${allocationDate.getFullYear()}`
      });
    }
  }

  xoaPhanBo(index: number) {
    if (index >= 0 && index < this.danhSachPhanBo.length) {
      this.danhSachPhanBo.splice(index, 1);
    }
  }

  loadPhanBo(id: any) {
    this.repo.postRequest('api/dangkygoihoc/getphanbo', { IdGuid: id })
      .subscribe(response => {
        if (response && Array.isArray(response)) {
          this.danhSachPhanBo = response.map(item => {
            return {
              ...item,
              Ngay: new Date(item.Ngay)
            };
          });
        }
      });
  }

  public saveproduct() {

    this.doituongSelect.DonViId = this.donviid;

    if (this.doituongSelect.LopId == null) {
      swal('Lỗi!', 'Vui lòng nhập lớp!.', 'error');
      return;
    }
    if (this.doituongSelect.NgayDangKy == null) {
      swal('Lỗi!', 'Vui lòng nhập ngày đăng ký!.', 'error');
      return;
    }
    //if (this.doituongSelect.KhoaHocId == null) {
    //  swal('Lỗi!', 'Vui lòng nhập khóa học!.', 'error');
    //  return;
    //}

    if (this.doituongSelect.GiaPhi == null) {
      this.doituongSelect.GiaPhi = 0;
      //swal('Lỗi!', 'Vui lòng nhập giá phí!.', 'error');
      //return;
    }

    if (this.doituongSelect.Nhom == null) {
      swal('Lỗi!', 'Vui lòng nhập loại!.', 'error');
      return;
    }
    if (this.doituongSelect.SoBuoi == null) {
      this.doituongSelect.SoBuoi = 0;
      //swal('Lỗi!', 'Vui lòng nhập số buổi!.', 'error');
      //return;
    }

    if (this.doituongSelect.ThucThu == null) {
      this.doituongSelect.ThucThu = 0;
      //swal('Lỗi!', 'Vui lòng nhập thực thu!.', 'error');
      //return;
    }
   
    //this.doituongSelect.TrangThai = this.doituongSelect.TrangThai == true ? 1 : 0;
    console.log(this.doituongSelect);

    if (this.doituongSelect.ThucThu == 0) {
      swal({
        title: this.ngonngu('Xác nhận thực thu =0?'),
        text: this.ngonngu('Bạn có chắc chắn muốn lưu đăng ký với số thực thu =0?'),
        icon: 'warning',
        buttons: {
          cancel: {
            text: this.ngonngu('Hủy'),
            value: false,
            visible: true
          },
          confirm: {
            text: this.ngonngu('Xác nhận'),
            value: true,
            className: 'bg-danger'
          }
        }
      }).then((willDelete) => {
        if (willDelete) {
          $('#loading').show();
          this.repo.postRequest("api/dangkygoihoc/addorupdate_dangky", this.doituongSelect)
            .subscribe(response => {
              if (response != null && response.match('-')) {
                this.doituongSelect.Id = response;

                // Now save the allocations if we have any
                if (this.danhSachPhanBo.length > 0) {
                  // Update ChungTuId for all allocations
                  this.danhSachPhanBo.forEach(item => {
                    item.ChungTuId = this.doituongSelect.Id;
                  });

                  this.repo.postRequest("api/dangkygoihoc/savephanbo", {
                    ChungTuId: this.doituongSelect.Id,
                    DanhSachPhanBo: this.danhSachPhanBo
                  }).subscribe(phanBoResponse => {
                    $('#loading').hide();
                    if (phanBoResponse && phanBoResponse.Success) {
                      this.save.emit(this.doituongSelect);
                    } else {
                      swal('Cảnh báo!', 'Lưu phân bổ doanh thu không thành công!', 'warning');
                      this.save.emit(this.doituongSelect);
                    }
                  }, error => {
                    $('#loading').hide();
                    swal('Lỗi!', 'Có lỗi xảy ra khi lưu phân bổ doanh thu!', 'error');
                    this.save.emit(this.doituongSelect);
                  });
                } else {
                  $('#loading').hide();
                  this.save.emit(this.doituongSelect);
                }
              } else {
                $('#loading').hide();
                swal('Lỗi!', response, 'error');
              }
            }, error => {
              $('#loading').hide();
              swal('Lỗi!', 'Có lỗi xảy ra khi lưu dữ liệu!', 'error');
            });


        }
      });
    }
    else {
      $('#loading').show();
      this.repo.postRequest("api/dangkygoihoc/addorupdate_dangky", this.doituongSelect)
        .subscribe(response => {
          if (response != null && response.match('-')) {
            this.doituongSelect.Id = response;

            // Now save the allocations if we have any
            if (this.danhSachPhanBo.length > 0) {
              // Update ChungTuId for all allocations
              this.danhSachPhanBo.forEach(item => {
                item.ChungTuId = this.doituongSelect.Id;
              });

              this.repo.postRequest("api/dangkygoihoc/savephanbo", {
                ChungTuId: this.doituongSelect.Id,
                DanhSachPhanBo: this.danhSachPhanBo
              }).subscribe(phanBoResponse => {
                $('#loading').hide();
                if (phanBoResponse && phanBoResponse.Success) {
                  this.save.emit(this.doituongSelect);
                } else {
                  swal('Cảnh báo!', 'Lưu phân bổ doanh thu không thành công!', 'warning');
                  this.save.emit(this.doituongSelect);
                }
              }, error => {
                $('#loading').hide();
                swal('Lỗi!', 'Có lỗi xảy ra khi lưu phân bổ doanh thu!', 'error');
                this.save.emit(this.doituongSelect);
              });
            } else {
              $('#loading').hide();
              this.save.emit(this.doituongSelect);
            }
          } else {
            $('#loading').hide();
            swal('Lỗi!', response, 'error');
          }
        }, error => {
          $('#loading').hide();
          swal('Lỗi!', 'Có lỗi xảy ra khi lưu dữ liệu!', 'error');
        });
    }

    
    }
   
  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
  indexdt: number;
  cotdt: string;

  

  


}
